// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_va-0";
export var checkoutRateBadgeLink = "_va-1";